import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ClientById, ClientInteraction, ListClientInteraction, TENANTSINTERFACE, Thread, ThreadResponse } from '@fitness-force/models';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationService } from '@fitness-force/api';
import { ToastMessageService } from '@fitness-force/api';
import { AvatarModule } from 'primeng/avatar';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { SelectModule } from 'primeng/select';
import { EditorModule } from 'primeng/editor';
import { InputTextModule } from 'primeng/inputtext';
import { PopoverModule } from 'primeng/popover';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SkeletonModule } from 'primeng/skeleton';
import { BehaviorSubject, interval, Subscription, take } from 'rxjs';
import { ConversationLogsComponent } from "@fitness-force/shared";
import { ClientService } from '@fitness-force/api';
import { TENANTS_INFO } from 'apps/ff-frontend/src/app/state/app.state';
import { DateTimeFormatPipe } from 'libs/pipes/datetime-format/src/lib/datetimeformat.pipe';
import { ShortNamePipe } from 'libs/pipes/short-name/src/lib/name-initials.pipe';
import { ClientProfileLeftSideComponent } from '@fitness-force/client-profile-lib';
import { ActivatedRoute } from '@angular/router';
import { ScrollerModule } from 'primeng/scroller';
import { CommunicationDirection } from '@fitness-force/enum';
import { TimeconversionService } from '@fitness-force/api';
import { ReplyComponent } from '@fitness-force/shared';

interface FilterState {
  channels: string[];
  conversationType: string | null;
}

@Component({
  selector: 'app-inbox',
  templateUrl: './inbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
        FormsModule,
        TranslateModule,
        ButtonModule,
        SkeletonModule,
        AvatarModule,
        BadgeModule,
        ScrollPanelModule,
        PopoverModule,
        CheckboxModule,
        DividerModule,
        SelectModule,
        EditorModule,
        InputTextModule,
        ConversationLogsComponent,
        ClientProfileLeftSideComponent,
        DateTimeFormatPipe,
        ShortNamePipe,
        ReplyComponent,
        TranslateModule,
        ScrollerModule
  ]
})
export class InboxComponent implements OnInit, OnDestroy {
  @ViewChild('filters') filters: any;
  @ViewChild('scroller') scroller: any;

  tenantId: number = 0;
  showSkeleton = true;
  showConversation = false;
  showWhatsapp = false;
  showEmail = false;
  showSMS = false;
  emailSelected = false;
  editorText = '';
  selectedReply: any;
  selectedThread: Thread | null = null;
  threads$ = new BehaviorSubject<Thread[]>([]);
  allThreads: Thread[] = [];
  totalThreads = 0;
  currentPage = 1;
  pageSize = 20;
  isLoadingMore = false;
  hasMoreResults = true;
  requestParams = new Map();
  interactionsParams = new Map();
  clientById: ClientById | null = null;
  Interactions = new BehaviorSubject<ClientInteraction[]>([]);
  showSkeletonForInteractions = new BehaviorSubject<boolean>(true);
  clientId: number = 0;
  threadId: number = 0;
  showCloseIcon$ = new BehaviorSubject<boolean>(false);
  showRefreshButton$ = new BehaviorSubject<boolean>(false);
  refreshButtonLoader$ = new BehaviorSubject<boolean>(false);
  private readonly pollingInterval = 20000; // 20 seconds in milliseconds
  private readonly maxPollCount = 15;
  private pollCount = 0;

  filterState: FilterState = {
    channels: [],
    conversationType: null // 'all', 'my_clients', 'all_clients'
  };

  filteredThreads$ = new BehaviorSubject<Thread[]>([]);
  lastInteraction: ClientInteraction = {} as ClientInteraction;
  showDotColor: string = 'text-red-500';
  private lastScrollPosition: number = 0;
  isNewConversation = false;
  private pollingSubscription: Subscription | undefined;
  private pollingSubscriptionForInteractions: Subscription | undefined;

  constructor(
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef,
    private store: Store,
    public toastMessageService: ToastMessageService,
    private timeService: TimeconversionService,
    private clientService: ClientService,
    private route: ActivatedRoute
  ) {
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
  }

  ngOnInit() {
    if (this.route.snapshot.paramMap.get('id')) {
      this.clientId = parseInt(this.route.snapshot.paramMap.get('id')!);
    }
    this.store.select(TENANTS_INFO).subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id;
      if (this.tenantId > 0) {
        this.tenantId = tenant.selected_tenant.id;
        this.store.dispatch({ type: 'ROUTER_GO' });
        this.filterState.conversationType = 'OneOnOneTransaction';
        this.loadThreads();
      }
    });
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }


  ngAfterViewInit() {
    setTimeout(() => {
      this.startPolling();
    }, 10000);
  } 

  loadThreads() {
    this.showSkeleton = true;
    this.requestParams.set('PageNumber', { name: 'PageNumber', value: this.currentPage });
    this.requestParams.set('PageSize', { name: 'PageSize', value: this.pageSize });
    if(this.filterState.conversationType && this.filterState.conversationType != null) {
      this.requestParams.set('type', { name: 'type', value: this.filterState.conversationType });
    }
    this.notificationService.getClientThreads(this.tenantId, Array.from(this.requestParams.values())).subscribe({
      next: (response: ThreadResponse) => {
        const threads = response.items ? response.items as Thread[] : [];
        var uniqueThreads = [...new Map(threads.map(thread => [thread.thread_id, thread])).values()];

        uniqueThreads = uniqueThreads.filter(thread => thread.client_id !== 0 && thread.client !== null);
        
        if (this.currentPage === 1) {
          this.allThreads = uniqueThreads;
          this.threads$.next(uniqueThreads.filter(thread => thread.thread_id !== ''));
        } else {
          this.allThreads = [...this.allThreads, ...uniqueThreads];
          this.threads$.next(this.allThreads.filter(thread => thread.thread_id !== ''));
        }

        if (this.filterState.channels.length > 0) {
          this.filteredThreads$.next(uniqueThreads.filter(thread => this.filterState.channels.includes(thread.communication_type)));
        }
        // if(this.filterState.conversationType === 'my_clients') {
        //   this.filteredThreads$.next(uniqueThreads.filter(thread => thread.client_id === this.clientId));
        // }
        // else if(this.filterState.conversationType === 'all_clients') {
        //   this.filteredThreads$.next(uniqueThreads);
        // }
        else {
          this.filteredThreads$.next(this.threads$.value);
        }
        this.totalThreads = response.total_items;
        this.hasMoreResults = uniqueThreads.length >= this.pageSize;
        if (this.clientId > 0) {
          this.selectThread(this.threads$.value.find(thread => thread.client_id === this.clientId)!);
        }
        this.showSkeleton = false;
        this.isLoadingMore = false;
        this.refreshButtonLoader$.next(false);
        this.cdr.markForCheck();
      },
      error: (error) => {
        this.toastMessageService.showError(error);
        this.showSkeleton = false;
        this.isLoadingMore = false;
        this.refreshButtonLoader$.next(false);
        this.cdr.markForCheck();
      }
    });
  }

  loadMoreThreads(event: any) {
    const { first, last } = event;
    
    // Check if we should load more data
    const shouldLoadMore = 
      !this.isLoadingMore && 
      this.hasMoreResults && 
      first > 0 && 
      last > 0 && 
      last >= (this.threads$.value.length - 5) && // Start loading when near the end
      this.threads$.value.length < this.totalThreads; // Check if we haven't loaded all threads yet

    if (shouldLoadMore) {
      // Store current scroll position
      this.lastScrollPosition = this.scroller?.elementViewChild?.nativeElement.scrollTop || 0;
      
      this.isLoadingMore = true;
      this.currentPage++;
      this.requestParams.set('PageNumber', { name: 'PageNumber', value: this.currentPage });
      this.requestParams.set('PageSize', { name: 'PageSize', value: this.pageSize });

      // Load new threads
      this.notificationService.getClientThreads(this.tenantId, Array.from(this.requestParams.values())).subscribe({
        next: (response: ThreadResponse) => {
          const threads = response.items ? response.items as Thread[] : [];
          const uniqueThreads = [...new Map(threads.map(thread => [thread.thread_id, thread])).values()];
          
          // Only add new threads if we received some
          if (uniqueThreads.length > 0) {
            this.allThreads = [...this.allThreads, ...uniqueThreads];
            this.threads$.next(this.allThreads.filter(thread => thread.thread_id !== ''));
            
            // Apply current filters
            if (this.filterState.channels.length > 0) {
              this.filteredThreads$.next(this.allThreads.filter(thread => 
                this.filterState.channels.includes(thread.communication_type)
              ));
            } else {
              this.filteredThreads$.next(this.threads$.value);
            }
          }
          
          this.totalThreads = response.total_items;
          // Update hasMoreResults based on whether we received a full page of results
          this.hasMoreResults = uniqueThreads.length >= this.pageSize && this.threads$.value.length < this.totalThreads;
          this.isLoadingMore = false;
          
          // Restore scroll position after data is loaded
          setTimeout(() => {
            if (this.scroller?.elementViewChild?.nativeElement) {
              this.scroller.elementViewChild.nativeElement.scrollTop = this.lastScrollPosition;
            }
          });
          
          this.cdr.markForCheck();
        },
        error: (error) => {
          this.toastMessageService.showError(error);
          this.isLoadingMore = false;
          this.cdr.markForCheck();
        }
      });
    }
  }

  onChannelFilterChange(event: any, channel: string) {
    if (event.checked) {
      this.filterState.channels.push(channel);
    } else {
      this.filterState.channels = this.filterState.channels.filter(ch => ch !== channel);
    }
    if (this.filterState.channels.length > 0) {
      this.showSkeleton = true;
      this.filteredThreads$.next(this.allThreads.filter(thread => this.filterState.channels.includes(thread.communication_type)));
      this.showSkeleton = false;
    }
    else {
      this.showSkeleton = true;
      this.filteredThreads$.next(this.allThreads);
      this.showSkeleton = false;
    }
    this.cdr.markForCheck();
  }


  onConversationTypeChange(type: string) {
    this.filterState.conversationType = type;
    if(type == null) {
      this.requestParams.delete('type');
    }
    else {
      this.requestParams.set('type', { name: 'type', value: type });
    }
    this.resetAndReload();
  }

  private resetAndReload() {
    this.currentPage = 1;
    this.hasMoreResults = true;
    this.allThreads = [];
    this.threads$.next([]);
    if (this.scroller) {
      this.scroller.scrollToIndex(0);
    }
    this.loadThreads();
  }

  showWhatsappMsgs() {
    this.showWhatsapp = true;
    this.showEmail = false;
    this.showSMS = false;
    this.showConversation = true;
  }

  showEmailMsgs() {
    this.showWhatsapp = false;
    this.showEmail = true;
    this.showSMS = false;
    this.showConversation = true;
  }

  showSMSMsgs() {
    this.showWhatsapp = false;
    this.showEmail = false;
    this.showSMS = true;
    this.showConversation = true;
  }

  selectThread(thread: Thread) {
    this.Interactions.next([]);
    this.isNewConversation = false;
    this.showSkeletonForInteractions.next(true);
    this.clientById = null;
    this.selectedThread = null;
    this.cdr.markForCheck();
    this.selectedThread = thread;
    this.showConversation = true;
    this.interactionsParams.set('thread_id', { paramName: 'thread_id', paramValue: thread.thread_id });
    this.interactionsParams.set('tenant_id', { paramName: 'tenant_id', paramValue: thread.tenant_id });
    this.interactionsParams.set('interaction_types', { paramName: 'interaction_types', paramValue: [thread.communication_type] });
    this.getClientDetails(thread.client_id);
    this.stopPollingForInteractions();
    setTimeout(() => {
      this.startPoolingForInteractions();
    }, 2000);
    this.cdr.markForCheck();
  }

  getThreadIcon(type: string): string {
    switch(type.toLowerCase()) {
     case 'whatsapp':
        return 'fab fa-whatsapp';
      case 'email':
        return 'fa fa-envelope';
      case 'sms':
        return 'fa fa-comment';
      default:
        return 'fa fa-comment';
    }
  }

  getThreadIconClass(type: string): string {
    switch(type.toLowerCase()) {
        case 'whatsapp':
            return 'whatsapp-bg';
        case 'email':
            return 'bg-orange-500';
        case 'sms':
            return 'bg-pink-500';
        default:
            return 'bg-primary';
    }
  }

  getClientDetails(clientId: number) {
    this.clientService.getClientById(clientId).subscribe((client: ClientById) => {
      this.clientById = client;
      this.getInteractions(clientId, Array.from(this.interactionsParams.values()));
    });
  }

  getInteractions(clientId: number, params: any[]) {
    this.clientService.getClientInteractions(clientId, params).subscribe((interactions: ListClientInteraction) => {
      this.lastInteraction = interactions.items ? interactions.items.sort((a, b) => new Date(a.log_date).getTime() - new Date(b.log_date).getTime())[interactions.items.length - 1] : {} as ClientInteraction;
      this.Interactions.next(interactions.items ? interactions.items : []);
      this.hasRecentIncomingWhatsApp(interactions.items ? interactions.items : []);
      this.showSkeletonForInteractions.next(false);
      if(this.selectedThread!.unead_messages_count > 0) this.markAsRead(clientId, this.lastInteraction);
      this.cdr.markForCheck();
    });
  }

  markAsRead(clientId: number, interaction: ClientInteraction) {
    var service:any;
    if(interaction.interaction_type.toLowerCase() == 'whatsapp') {
      service = this.notificationService.markAsWhatsappRead(this.tenantId, clientId, interaction.interaction_id);
    }
    else if(interaction.interaction_type.toLowerCase() == 'sms') {  
      service = this.notificationService.markAsSmsRead(this.tenantId, clientId, interaction.interaction_id);
    }
    else {
      service = this.notificationService.markAsRead(this.tenantId, clientId, this.selectedThread!.thread_id, interaction.interaction_id);
    }
    service.subscribe({
      next: (res: any) => {
        this.selectedThread!.unead_messages_count = 0;
        var data = this.filteredThreads$.value;
        data.forEach(thread => {
          if(thread.thread_id === this.selectedThread!.thread_id) {
            thread.unead_messages_count = 0;
          }
        });
        this.filteredThreads$.next(data); 
        this.cdr.detectChanges();
      },
      error: (error: any) => {
        console.log(error);
      }
    });
  } 

  // markAsUnread(clientId: number, interactionId: number) {
  //   this.notificationService.markAsUnread(this.tenantId, clientId, this.selectedThread!.thread_id, interactionId).subscribe((res: any) => {
  //     console.log(res);
  //   });
  // } 

  startNewConversation() {
    this.Interactions.next([]);
    this.isNewConversation = true;
    this.lastInteraction = {} as ClientInteraction;
    this.cdr.detectChanges();
  }

  getInteractionContent(message: string): any {
    const original = message || '';
    const isHtml = /<[a-z][\s\S]*>/i.test(original);
    
    try {
      const content = isHtml ? 
        this.parseHtmlContent(original) : 
        this.cleanupPlainText(original);

      return {
        content,
        isHtml,
        originalLength: original.length,
        parsedLength: content.length,
        format: this.detectMessageFormat(original)
      };
    } catch (error) {
      return {
        content: this.cleanupPlainText(original),
        isHtml: false,
        originalLength: original.length,
        parsedLength: original.length,
        format: 'plain'
      };
    }
  }

  private parseHtmlContent(htmlString: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;

    // 1. Remove dangerous elements
    const dangerousElements = tempDiv.querySelectorAll('script, style, iframe, link');
    dangerousElements.forEach(el => el.remove());

    // 2. Remove email quotes and signatures
    const emailElements = tempDiv.querySelectorAll('blockquote, .gmail_quote, .gmail_signature, .signature');
    emailElements.forEach(el => el.remove());

    // 3. Handle different message formats
    let content = '';

    // Try to find message content in common containers
    const messageContainers = tempDiv.querySelectorAll(
      '.message-content, .email-body, .whatsapp-message, [data-testid="msg-container"], .message-text'
    );

    if (messageContainers.length > 0) {
      content = Array.from(messageContainers)
        .map(container => container.textContent)
        .join('\n');
    } else {
      // If no specific containers found, process all text nodes
      content = this.extractTextFromNodes(tempDiv);
    }

    return this.cleanupPlainText(content);
  }

  private extractTextFromNodes(element: HTMLElement): string {
    let text = '';
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT,
      null
    );

    let node;
    while (node = walker.nextNode()) {
      if (node.nodeType === Node.TEXT_NODE) {
        const nodeText = node.textContent?.trim() || '';
        if (nodeText) {
          text += nodeText + ' ';
        }
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        const element = node as HTMLElement;
        // Add line breaks for block elements and breaks
        if (this.isBlockElement(element) || element.tagName === 'BR') {
          text += '\n';
        }
      }
    }

    return text;
  }

  private isBlockElement(element: HTMLElement): boolean {
    const blockElements = [
      'DIV', 'P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6',
      'UL', 'OL', 'LI', 'BLOCKQUOTE', 'TABLE', 'TR',
      'SECTION', 'ARTICLE', 'HEADER', 'FOOTER'
    ];
    return blockElements.includes(element.tagName);
  }

  private cleanupPlainText(text: string): string {
    return text
      // Replace HTML entities
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      // Remove excessive whitespace
      .replace(/\s+/g, ' ')
      // Fix line breaks
      .replace(/\n\s*\n/g, '\n')
      // Remove email forwarding/reply markers
      .replace(/^-{3,}Forwarded message-{3,}[\s\S]*?(?=\n{2})/gm, '')
      .replace(/^On.*wrote:$/gm, '')
      // Remove common separators
      .replace(/_{3,}|-{3,}|\*{3,}/g, '')
      // Remove WhatsApp timestamps
      .replace(/\[\d{1,2}:\d{2}(?::\d{2})?\s*(?:AM|PM)?\]/g, '')
      // Remove leading/trailing whitespace
      .trim();
  }

  private detectMessageFormat(message: string): 'plain' | 'html' | 'email' | 'whatsapp' | 'sms' {
    // Check for WhatsApp specific markers
    if (message.includes('data-testid="msg-container"') || 
        message.includes('class="whatsapp-message"')) {
      return 'whatsapp';
    }
    
    // Check for email specific markers
    if (message.includes('gmail_quote') || 
        message.includes('outlook.com') ||
        /^On.*wrote:$/m.test(message) ||
        message.includes('Forwarded message')) {
      return 'email';
    }
    
    // Check for SMS specific markers (you may need to adjust based on your SMS format)
    if (message.includes('class="sms-message"') ||
        message.includes('data-type="sms"')) {
      return 'sms';
    }
    
    // Check if it's HTML
    if (/<[a-z][\s\S]*>/i.test(message)) {
      return 'html';
    }
    
    // Default to plain text
    return 'plain';
  }

  hasRecentIncomingWhatsApp(interactions: ClientInteraction[]) {
    try {
      if (!interactions || interactions.length === 0) {
        this.showDotColor = 'text-red-500';
        return;
      }
      const currentTime = new Date();

      interactions = interactions.filter(interaction => interaction.interaction_type?.toLowerCase() == 'whatsapp' && (interaction.direction == CommunicationDirection.Incoming || interaction.direction.toString() == CommunicationDirection[CommunicationDirection.Incoming]));

      var isActive = interactions.some(interaction => {
        // Get interaction time and calculate difference
        const interactionTime = this.timeService.ConvertUTCToLocalDateTime(interaction.log_date);
        const hoursDifference = (currentTime.getTime() - interactionTime.getTime()) / (1000 * 60 * 60);
        return hoursDifference < 24;
      });
      if(isActive) this.showDotColor = 'text-green-500';
      else this.showDotColor = 'text-red-500';

    } catch (error) {
      console.error('Error checking for recent incoming WhatsApp:', error);
    }

  }

  getNewInteraction(event: any) {
    this.Interactions.next([...this.Interactions.value, event]);
    this.cdr.detectChanges();
  }

  private handleVisibilityChange(): void {
    if (document.hidden) {
      // Stop polling when page is hidden
      this.stopPolling();
      this.stopPollingForInteractions();
      // Store the last polling time
    } else {
      // Restart polling if we haven't reached max count
      if (this.pollCount < this.maxPollCount) {
        this.startPolling();
        this.startPoolingForInteractions();
      }
    }
  }

  startPolling(): void {
    // Prevent multiple polling subscriptions
    if (this.pollingSubscription || document.hidden) {
      return;
    }

    // Make an immediate call first if we haven't reached max count
    if (this.pollCount < this.maxPollCount) {
      this.loadThreads();
    }

    // Start the interval
    this.pollingSubscription = interval(this.pollingInterval)
      .pipe(
        take(this.maxPollCount - this.pollCount) // Ensure we don't exceed maxPollCount
      )
      .subscribe({
        next: () => {
          if (document.hidden) {
            this.stopPolling();
            return;
          }
          
          this.pollCount++;
          this.loadThreads();
          
          if (this.pollCount >= this.maxPollCount) {
            this.stopPolling();
            this.showRefreshButton$.next(true);
          }
        },
        complete: () => {
          this.stopPolling();
          this.showRefreshButton$.next(true);
        }
      });
  }

  startPoolingForInteractions() {
   // Prevent multiple polling subscriptions
   if (this.pollingSubscriptionForInteractions || document.hidden) {
    return;
  }

  // Make an immediate call first if we haven't reached max count
  if (this.pollCount < this.maxPollCount) {
    this.getInteractions(this.selectedThread!.client_id, Array.from(this.interactionsParams.values()));
  }

  // Start the interval
  this.pollingSubscriptionForInteractions = interval(this.pollingInterval)
    .pipe(
      take(this.maxPollCount - this.pollCount) // Ensure we don't exceed maxPollCount
    )
    .subscribe({
      next: () => {
        if (document.hidden) {
          this.stopPollingForInteractions();
          return;
        }
        
        this.pollCount++;
        this.getInteractions(this.selectedThread!.client_id, Array.from(this.interactionsParams.values()));
        
        if (this.pollCount >= this.maxPollCount) {
          this.stopPollingForInteractions();
        }
      },
      complete: () => {
        this.stopPollingForInteractions();
      }
    });
  }

  private stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
      this.pollingSubscription = undefined;
    }
  }

  private stopPollingForInteractions(): void {
    if (this.pollingSubscriptionForInteractions) {
      this.pollingSubscriptionForInteractions.unsubscribe();
      this.pollingSubscriptionForInteractions = undefined;
    }
  }

  refreshThreads(): void {
    this.refreshButtonLoader$.next(true);
    this.loadThreads();
    
    // Reset refresh button loader after a short delay
    setTimeout(() => {
      this.refreshButtonLoader$.next(false);
      this.showRefreshButton$.next(false);
      this.cdr.detectChanges();
    }, 1000);
  }

  ngOnDestroy(): void {
    this.stopPolling();
    this.stopPollingForInteractions();
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }
} 
